const CLASS_NAME = 'loci--components--form--radio';

export { CLASS_NAME };
export default {};
